import { APPT_BOOKING_REASON_MAX, APPT_BOOKING_REASON_MIN } from "common/constants";
import { string } from "yup";

export const apptBookReasonValidation = (required = true) => {
	let schema = string();

	if (required) {
		schema = schema
			.min(APPT_BOOKING_REASON_MIN, `Must be at least ${APPT_BOOKING_REASON_MIN} characters`)
			.required("Required");
	} else {
		// Apply min only if user has entered a value
		schema = schema
			.notRequired()
			.test(
				"min-if-filled",
				`Must be at least ${APPT_BOOKING_REASON_MIN} characters`,
				value => !value || value.length >= APPT_BOOKING_REASON_MIN
			);
	}

	schema = schema.max(APPT_BOOKING_REASON_MAX, `Must be at most ${APPT_BOOKING_REASON_MAX} characters`);

	return schema;
};

export const stringRequired = (fieldName, { min = 1, max = 1500 } = {}) => string()
	.required(`${fieldName} is required`)
	.max(max, `${fieldName} must be at most ${max} characters`)
	.min(min, `${fieldName} must be at least ${min} characters`)